import React, {useEffect, useState} from "react";

import Util from "../../helpers/util";
import Language from "../../helpers/language";

import { ConfirmModal } from "../../modals/confirm_modal";
import {ImportFileModal} from "../../modals/admin/import_file_modal";
import {ContentType} from "../../helpers/consts";
import { TrashIcon } from "@heroicons/react/20/solid";
import {DocumentAcceptanceModal} from "../../modals/admin/document_acceptance_modal";

export const DocumentAcceptanceTab = (props) => {
    const { tenant_uid, showToast } = props

    const [state, setState] = useState({
        search: "",
        documents: [],
        selected: {},
        confirm: null,
        upload_document: false
    })
    const { search, documents, selected, confirm, upload_document } = state

    useEffect(() => {
        updateList()
    }, [])

    const updateList = () => {
        Util.fetch_js( "/question/list/", { tenant_uid, include_types: [ContentType.Document], exclude_empty: true, detailed: true },
            js => {
                const documents = js.categories.map(cat =>
                    cat.questions.filter(q => q.contents.length > 0).map(q =>
                        ({ ...q,
                           filesize: q.contents[0].content.filesize,
                           document_url: q.contents[0].content.document,
                        }))
                ).flat()
                setState(prev => ({ ...prev,
                    documents
                }))
            },
            (reason, code) => {
                showToast(reason, 'failure');
            }
        );
    }

    const uploadFile = (text, file) => {
        Util.fetch_js( "/question/upload_document/", { tenant_uid, text, file },
            js => {
                showToast(Language.getTitleCase('uploaded document'), 'successful');
                updateList()

                setState(prev => ({...prev,
                    upload_document: false
                }))
            },
            (reason, code) => {
                showToast(reason, 'failure');
                setState(prev => ({...prev,
                    upload_document: false
                }))
            }
        );
    }

    const filterDocuments = (search, documents) => {
        //Do nothing
        if (search === "") {
            return documents
        }

        //Only keep
        const search_lc = search.toLowerCase();
        return documents.filter(report =>
            report.name.toLowerCase().indexOf(search_lc) >= 0
        )
    }

    const handleSelect = (checked, uid) => {
        if (checked) {
            selected[uid] = true;
        }
        else if (uid in selected) {
            delete selected[uid];
        }

        setState(prev => ({ ...prev, selected }))
    }

    const handleSelectAll = (checked) => {
        let selected = {}

        //Check all?
        if (checked) {
            for (let i = 0; i < documents.length; i++) {
                selected[documents[i].uid] = true;
            }
        }

        setState(prev => ({ ...prev, selected }))
    }

    const handleChange = (e) => {
        setState(prev => ({...prev, [e.target.id]: e.target.value }))
    }

    const handleModalClose = (report) => {
        updateList()
        setState( prev => ({...prev,
            show_generate: null,
            generate_only: false,
            upload_document: false,
        }))
    }

    const handleRemove = (uid) => {
        const question_uids = uid ? [uid] : Object.keys(selected)
        console.log(question_uids)
        Util.fetch_js( "/question/remove/", { question_uids, clean_up: true },
            js => {
                showToast(Language.getTitleCase('deleted documents'), 'successful');
                updateList()
            },
            (err, code) => {
                showToast(err, 'failure');
            }
        );

        setState(prev => ({...prev, confirm: null, selected: {} }))
    }

    const confirmAction = (action) => {
        const new_confirm = {
            action,
            msg: Language.getTitleCase('remove documents'),
            yes: Language.getTitleCase('remove'),
            no: Language.getTitleCase('cancel')
        };

        setState(prev => ({...prev, confirm: new_confirm }))
    }

    const filtered_documents = filterDocuments(search, documents)

    return (
        <div className='curriculum main-modal'>
            <div className='central__main central__main--management'>
                <div className='central__head'>
                    <div className='central__head-search-wrapper'>
                        <svg
                            width='15'
                            height='16'
                            viewBox='0 0 15 16'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'>
                            <path
                                d='M14.8828 14.6152L11.3379 11.0703C11.25 11.0117 11.1621 10.9531 11.0742 10.9531H10.6934C11.6016 9.89844 12.1875 8.49219 12.1875 6.96875C12.1875 3.62891 9.43359 0.875 6.09375 0.875C2.72461 0.875 0 3.62891 0 6.96875C0 10.3379 2.72461 13.0625 6.09375 13.0625C7.61719 13.0625 8.99414 12.5059 10.0781 11.5977V11.9785C10.0781 12.0664 10.1074 12.1543 10.166 12.2422L13.7109 15.7871C13.8574 15.9336 14.0918 15.9336 14.209 15.7871L14.8828 15.1133C15.0293 14.9961 15.0293 14.7617 14.8828 14.6152ZM6.09375 11.6562C3.48633 11.6562 1.40625 9.57617 1.40625 6.96875C1.40625 4.39062 3.48633 2.28125 6.09375 2.28125C8.67188 2.28125 10.7812 4.39062 10.7812 6.96875C10.7812 9.57617 8.67188 11.6562 6.09375 11.6562Z'
                                fill='currentColor'></path>
                        </svg>
                        <input
                            type='text'
                            className='central__head-search'
                            placeholder={Language.getSentenceCase('Search by name') + '...'}
                            id='search'
                            value={search}
                            onChange={handleChange}
                        />
                    </div>

                    <div className='central__head-button-container'>
                        {Object.keys(selected).length > 0 && (
                            <button
                                type='button'
                                className='central__head-button central__head-button--remove'
                                name='remove-user'
                                onClick={() => confirmAction(yes => yes && handleRemove()) }>
                                {Language.getTitleCase('remove document')}
                            </button>
                        )}
                        <button
                          className='central__head-button central__head-button--solid central__head-button--add'
                          id='generateContent'
                          type='button'
                          onClick={() => setState(prev => ({...prev, upload_document: true  })) }>
                            {Language.getTitleCase('upload document')}
                        </button>
                    </div>
                </div>

                <table className='management__table'>
                    <tbody>
                        <tr className='management__table-row management__table-row--head'>
                            <th className='management__table-head management__table-head--input'>
                                <div className='d7__checkbox-container'>
                                    <input
                                        className='d7__checkbox'
                                        aria-label="checkbox"
                                        type='checkbox'
                                        checked={documents.length > 0 && documents.length == Object.keys(selected).length}
                                        onChange={e => handleSelectAll( e.target.checked )}/>
                                    <span className='dash'></span>
                                </div>
                            </th>
                            <th className='management__table-head management__table-head--name'>
                                <h5 className='management__table-heading'>
                                    {Language.getTitleCase('name')}
                                </h5>
                            </th>
                        </tr>
                        {Object.entries(filtered_documents).map(
                            ([key, report]) => (
                                <tr
                                    className='management__table-row management__table-row--body'
                                    key={"report_row_" + key}>
                                    <td className='management__table-data management__table-data--input'>
                                        <div className='d7__checkbox-container'>
                                            <input
                                                className='d7__checkbox'
                                                aria-label="checkbox"
                                                type='checkbox'
                                                checked={ report.uid in selected }
                                                onChange={e => handleSelect( e.target.checked, report.uid ) } />
                                            <span className='checkmark'></span>
                                        </div>
                                    </td>
                                    <td className='management__table-data management__table-data--name inline-flex justify-between w-full items-center'
                                        onClick={() => setState(prev => ({...prev, show_generate: report })) }>
                                        <h5 className='management__table-text cursor-pointer'
                                            onClick={() => window.open(report.document_url, '_blank')}>
                                            {report.name}
                                            &nbsp;-&nbsp;
                                            {Math.floor(report.filesize / 1000)}K
                                        </h5>
                                        <TrashIcon className='h-5 w-5 mr-5 text-gray-400 hover:text-red-500 cursor-pointer'
                                                   onClick={() => confirmAction(() => handleRemove(report.uid)) } />
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>

                {confirm != null && (
                    <ConfirmModal
                        msg={confirm.msg}
                        yesTxt={confirm.yes}
                        noTxt={confirm.no}
                        onYes={() => confirm.action(true)}
                        onNo={() => setState(prev => ({...prev, confirm: null }))}
                    />
                )}
            </div>

            <DocumentAcceptanceModal
                open={upload_document}
                load_on_start={true}
                title={Language.getTitleCase('upload Pdf')}
                accept=".pdf"
                onUpload={uploadFile}
                onClose={handleModalClose}
            />
        </div>
    );
};